import React, { useState } from "react";
import { 
    Breadcrumb, 
    NeoCard,
    NeoBadge
} from "../../../components/Common";

import AuditFilters from "./components/AuditFilters";
import AuditList from "./components/AuditList";
import AuditDetailsModal from "./components/AuditDetailsModal";
import useAuditLogs from "./hooks/useAuditLogs";

/**
 * AuditLogsPage — Página para consultar logs de auditoria do sistema.
 * Migrado para o Neo Design System (Taça Outono) de forma integrada e premium.
 */
const AuditLogsPage = () => {
    document.title = "Auditoria | NeoApp - Sistema de Gestão";

    // O hook gerencia tudo relacionado a banco e estado da listagem
    const {
        logs,
        loading,
        hasMore,
        filters,
        updateFilter,
        clearFilters,
        loadMore
    } = useAuditLogs();

    // Modal state
    const [selectedLog, setSelectedLog] = useState(null);

    const handleFilterSubmit = (newFilters) => {
        // Aplica todos de uma vez
        Object.keys(newFilters).forEach(key => updateFilter(key, newFilters[key]));
    };

    const handleClearFilters = () => {
        clearFilters();
    };

    const handleViewDetails = (log) => {
        setSelectedLog(log);
    };

    const toggleModal = () => setSelectedLog(null);

    return (
        <React.Fragment>
            <Breadcrumb title="Logs de Auditoria" breadcrumbItem="Segurança" />

            <div className="audit-container mt-3">
                <NeoCard
                    title="Registros de Auditoria"
                    subtitle="Histórico completo de alterações, criações e exclusões no sistema."
                    headerIcon="mdi-shield-check-outline"
                    headerActions={
                        <NeoBadge color="light">
                            Histórico de Ações
                        </NeoBadge>
                    }
                >
                    {/* Componente de Filtros (Card Horizontal ou Row) */}
                    <AuditFilters 
                        filters={filters}
                        onFilterSubmit={handleFilterSubmit}
                        onClearFilters={handleClearFilters}
                    />

                    {/* Tabela Paginada */}
                    <div className="pt-2 border-top mt-3">
                        <AuditList
                            logs={logs}
                            loading={loading}
                            hasMore={hasMore}
                            onLoadMore={loadMore}
                            onViewDetails={handleViewDetails}
                        />
                    </div>
                </NeoCard>
            </div>

            {/* Modal de Detalhes - renderiza os diffs do objeto de auditoria */}
            {selectedLog && (
                <AuditDetailsModal 
                    isOpen={!!selectedLog}
                    toggle={toggleModal}
                    log={selectedLog}
                />
            )}
        </React.Fragment>
    );
};

export default AuditLogsPage;
